(() => {
    let hasDoneScroll = false

    window.addEventListener('parcelsRendered', function (e) {
        if (hasDoneScroll || window.innerWidth > 990) {
            return
        }

        window.scrollTo(
            0,
            document.querySelector('#trackandtrace__contentcontainer > :first-child').getBoundingClientRect().top + window.scrollY - 105
        )
        hasDoneScroll = true
    })
}) ()
